<template>
<div class="main">
  <div class="sidebar">
    <v-sidebar></v-sidebar>
  </div>
  <div class="content-box">
    <Layout />
  </div>
</div>
</template>

<script>
import vSidebar from '../../components/ssp/app/pSidebar.vue'
import Layout from '../../components/ssp/routerLayout/layout.vue'
export default {
  components:{
    vSidebar,
    Layout
  }
}
</script>

<style>
</style>
